import { diagnosticLog } from './diagnosticLogger';
import { getConnectorVersion, isConnectorInWindowsExclusiveKillRange } from './connectorVersion';
import { isWindowsConnectorHost } from './platform';

const KILL_SWITCH_DIAGNOSTIC = 'exclusive suppressed on Windows pending v164 — WASAPI arbiter crash';

/** Thrown from connector.exclusivePlay when the Windows v160–163 kill switch is active. */
export const WINDOWS_EXCLUSIVE_KILL_SWITCH_ERROR =
  `exclusive_mode_not_allowed: ${KILL_SWITCH_DIAGNOSTIC}`;

/** KILL SWITCH — remove when v164 ships */
export function isWindowsExclusiveKillSwitchActive(): boolean {
  return isWindowsConnectorHost() && isConnectorInWindowsExclusiveKillRange();
}

export function logWindowsExclusiveKillSwitch(): void {
  console.warn(`[exclusive] ${KILL_SWITCH_DIAGNOSTIC}`);
  diagnosticLog('warn', 'transport', KILL_SWITCH_DIAGNOSTIC, {
    connectorVersion: getConnectorVersion(),
  });
}

/** True when exclusive_play IPC must not be invoked (Windows 11.0.160–11.0.163). */
export function shouldBlockWindowsExclusivePlay(): boolean {
  if (!isWindowsExclusiveKillSwitchActive()) return false;
  logWindowsExclusiveKillSwitch();
  return true;
}
